

export const frontMatter = {
	slug: 'dockview-1.4.1-release',
	title: 'Dockview 1.4.1',
	tags: [
		'release'
	]
};
export const contentTitle = 'Release Notes';
export const metadata = {
  "permalink": "/blog/dockview-1.4.1-release",
  "source": "@site/blog/2022-05-11-dockview-1.4.1.mdx",
  "title": "Dockview 1.4.1",
  "description": "🚀 Features",
  "date": "2022-05-11T00:00:00.000Z",
  "formattedDate": "May 11, 2022",
  "tags": [
    {
      "label": "release",
      "permalink": "/blog/tags/release"
    }
  ],
  "readingTime": 0.635,
  "hasTruncateMarker": false,
  "authors": [],
  "frontMatter": {
    "slug": "dockview-1.4.1-release",
    "title": "Dockview 1.4.1",
    "tags": [
      "release"
    ]
  },
  "unlisted": false,
  "prevItem": {
    "title": "Dockview 1.4.2",
    "permalink": "/blog/dockview-1.4.2-release"
  }
};
export const assets = {
"authorsImageUrls": [],
};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "🚀 Features",
  "id": "-features",
  "level": 2
}, {
  "value": "🛠 Miscs",
  "id": "-miscs",
  "level": 2
}, {
  "value": "🔥 Breaking changes",
  "id": "-breaking-changes",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "-features",
      children: "🚀 Features"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Fix Drag and Drop issues in Dockview on Firefox ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/103",
          children: "#103"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "-miscs",
      children: "🛠 Miscs"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Documentation enhancements ", _jsx(_components.a, {
          href: "https://mathuo.github.io/dockview/docs/",
          children: "https://mathuo.github.io/dockview/docs/"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "-breaking-changes",
      children: "🔥 Breaking changes"
    }), "\n", _jsx(_components.p, {
      children: "All breaking changes here are designed to simplify the library with only one way to do something."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Remove ", _jsx(_components.code, {
          children: "setVisible"
        }), " and ", _jsx(_components.code, {
          children: "setActive"
        }), " from the Splitview API. You can still achieve the same behaviors through calling ", _jsx(_components.code, {
          children: "setVisible"
        }), " and ", _jsx(_components.code, {
          children: "setActive"
        }), " on the Splitview Panel API. ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/105",
          children: "#105"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Remove ", _jsx(_components.code, {
          children: "setVisible"
        }), ", ", _jsx(_components.code, {
          children: "setActive"
        }), " and ", _jsx(_components.code, {
          children: "toggleVisiblity"
        }), " from Gridview API. You can still achieve the same behaviors through calling ", _jsx(_components.code, {
          children: "setVisible"
        }), " and ", _jsx(_components.code, {
          children: "setActive"
        }), " on the Gridview Panel API ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/105",
          children: "#105"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Remove ", _jsx(_components.code, {
          children: "onFocusEvent"
        }), " from Panel API as this was not intended to be a public method. You can use ", _jsx(_components.code, {
          children: "onDidFocusChange"
        }), " instead ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/105",
          children: "#105"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Remove HOC ", _jsx(_components.code, {
          children: "<DockviewComponents.Panel\\>"
        }), ", ", _jsx(_components.code, {
          children: "<DockviewComponents.Content>"
        }), ", ", _jsx(_components.code, {
          children: "<DockviewComponents.Tab>"
        }), " and ", _jsx(_components.code, {
          children: "<DockviewComponents.Actions>"
        }), " ", _jsx(_components.a, {
          href: "https://github.com/mathuo/dockview/pull/105",
          children: "#105"
        })]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

